import { Component, inject, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { Header } from './core/components/header/header';
import { Footer } from './core/components/footer/footer';
import { RouterOutlet } from '@angular/router';
import { SideMenu } from './core/components/side-menu/side-menu';
import { ThemeService } from './core/services/theme.service';
import { Modal } from './shared/components/modal/modal';
import { SessionService } from './core/services/session.service';
import { LoadingService } from './core/services/loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [TegelModule, Header, Footer, RouterOutlet, SideMenu, Modal],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private readonly session = inject(SessionService);
  private readonly theme = inject(ThemeService);
  private readonly loading = inject(LoadingService);

  readonly themeClass = this.theme.themeClass;
  readonly isLoading = this.loading.isLoading;

  async ngOnInit(): Promise<void> {
    await this.session.initialize();
  }
}
